export type GovernanceVisibilitySettings = {
  showGovernance?: boolean;
};

/** Governance is opt-in and requires an explicit organisation setting. */
export function isGovernanceVisible(
  settings: GovernanceVisibilitySettings | undefined,
): boolean {
  return settings?.showGovernance === true;
}
